import type React from "react";
import { CustomCheckbox } from "~/components/ui/check_Box";
import styles from "../../index.module.scss";
import type { TextFieldComponentProps } from "../../types";

const SingleLineTextOptions: React.FC<TextFieldComponentProps> = ({
  options,
  handleTextOptionChange,
  handleBooleanOptionChange,
  isReadOnly,
}) => {
  // テキスト表示オプション
  const singleLineTextDisplayOptions = [
    { key: "unique", label: "値の重複を禁止する" },
    { key: "required", label: "必須項目にする" },
    { key: "noLabel", label: "フィールド名を表示しない" },
  ];

  return (
    <>
      <div className={styles["form-group"]}>
        <label>最小文字数</label>
        <input
          type="text"
          value={options.minLength || ""}
          onChange={(e) => handleTextOptionChange("minLength", e.target.value)}
          readOnly={isReadOnly}
        />
      </div>
      <div className={styles["form-group"]}>
        <label>最大文字数</label>
        <input
          type="text"
          value={options.maxLength || ""}
          onChange={(e) => handleTextOptionChange("maxLength", e.target.value)}
          readOnly={isReadOnly}
        />
      </div>
      <div className={styles["form-group"]}>
        <label>デフォルト値</label>
        <input
          type="text"
          value={options.defaultValue || ""}
          onChange={(e) => handleTextOptionChange("defaultValue", e.target.value)}
          readOnly={isReadOnly}
        />
      </div>

      {/* チェックボックスオプション */}
      {singleLineTextDisplayOptions.map((option) => (
        <div key={option.key} className={styles["form-group"]}>
          <CustomCheckbox
            label={option.label}
            checked={options[option.key] || false}
            onChange={(value) => handleBooleanOptionChange(option.key, value)}
            {...(isReadOnly !== undefined && { disabled: isReadOnly })}
          />
        </div>
      ))}
    </>
  );
};

export default SingleLineTextOptions;
